import dayjs from "dayjs";

const initialState = {
  respondedDetails: {
    respondedByID:"",
    respondedBy: "",
    designation: "",
    respondedStartDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    respondedEndDateandTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    taskCode: "",
    taskDescription: "",
    repairType: "",
    repairType: "",
    repairTypeID:"",
    vendorID:"",
    taskCodeID:""
  },
  otherRespondedDeatils: {
    assessmentId: "",
    selectedPartsRequired: "",
    selectedAssetTakenOut: "",
    outsourceRespondRemarks: "",
  },
  completionDetails: {
    completionId: "",
    rootCause: "",
    startDateandTime: "",
    endDateandTime: "",
    actionTaken: "",
  },
  repairTracker: [],
  partReplacementRows: [],
  workderStatus: "",
  vendorName:""
};



const routineInspectionWebFormReducer = (state = initialState, action) => {

  switch (action.type) {
    case 'ROUTINEINSPECTION_UPDATE_RESPONDED_DETAILS':
      return {
        ...state,
        respondedDetails: {
          ...state.respondedDetails,
          ...action.payload
        }
      };

    case 'ROUTINEINSPECTION_UPDATE_OTHER_RESPONDED_DETAILS':
      return {
        ...state,
        otherRespondedDeatils: {
          ...state.otherRespondedDeatils,
          ...action.payload
        }
      };


    case 'ROUTINEINSPECTION_UPDATE_COMPLETION_DETAILS':
      return {
        ...state,
        completionDetails: {
          ...state.completionDetails,
          ...action.payload,
        }
      };

    case 'ROUTINEINSPECTION_ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR':
      return {
        ...state,
        repairTracker: [
          ...state.repairTracker,
          action.payload,
        ],
      };

    case 'ROUTINEINSPECTION_DELETE_REPAIR_TRACKER_DETAILS_FOR_VENDOR':
      if (action?.payload?.dummy_id) {
        return {
          ...state,
          repairTracker: state?.repairTracker?.filter(
            (item) => item?.dummy_id !== action?.payload?.dummy_id
          ),
        };
      } else if (action?.payload?.id) {
        return {
          ...state,
          repairTracker: state?.repairTracker?.filter(
            (item) => item?.id !== action?.payload?.id
          ),
        };
      } else {
        return state;
      };

      case 'ROUTINEINSPECTION_UPDATE_REPAIR_TRACKER_DETAILS_FOR_VENDOR':
        if (action.payload?.dummy_id) {
          return {
            ...state,
            repairTracker: state?.repairTracker?.map((data) =>
              data?.dummy_id === action?.payload?.dummy_id
                ? { ...data, ...action.payload }
                : data
            ),
          };
        } else if (action.payload?.id) {
          return {
            ...state,
            repairTracker: state?.repairTracker?.map((data) =>
              data?.id === action?.payload?.id
                ? { ...data, ...action.payload }
                : data
            ),
          };
        } else {
          return;
        }

    case 'ROUTINEINSPECTION_CLEAR_REPAIR_TRACKER_FOR_VENDOR':
      return {
        ...state,
        repairTracker: []
      };

      case 'ROUTINEINSPECTION_PART_REPLACEMENT_FOR_VENDOR':
        return {
          ...state,
          partReplacementRows: [
            ...state.partReplacementRows,
            action.payload,
          ],
        };
  
      case 'ROUTINEINSPECTION_UPDATE_PART_REPLACEMENT_FOR_VENDOR':
        if (action.payload?.dummy_id) {
          return {
            ...state,
            partReplacementRows: state.partReplacementRows.map((item) =>
              item?.dummy_id === action?.payload?.dummy_id
                ? { ...item, ...action.payload }
                : item
            ),
          };
        } else if (action.payload?.id) {
          return {
            ...state,
            partReplacementRows: state.partReplacementRows.map((item) =>
              item?.id === action?.payload?.id
                ? { ...item, ...action.payload }
                : item
            ),
          };
        } else {
          return;
        }
  
      case 'ROUTINEINSPECTION_DELETE_PART_REPLACEMENT_FOR_VENDOR':
        if (action?.payload?.dummy_id) {
          return {
            ...state,
            partReplacementRows: state?.partReplacementRows?.filter(
              (item) => item?.dummy_id !== action?.payload?.dummy_id
            ),
          };
        } else if (action?.payload?.id) {
          return {
            ...state,
            partReplacementRows: state?.partReplacementRows?.filter(
              (item) => item?.id !== action?.payload?.id
            ),
          };
        } else {
          return;
        };
  
  
      case 'ROUTINEINSPECTION_CLEAR_PART_REPLACEMENT_FOR_VENDOR':
        return {
          ...state,
          partReplacementRows: []
        };
  

    case 'ROUTINEINSPECTION_UPDATE_FORMSUBMIT_STATUS':
      return {
        ...state,
        workderStatus: action?.payload
      }

    case 'GET_ROUTINEINSPECTION_VENDORNAME':
      return {
        ...state,
        vendorName: action?.payload
      }

    case 'ROUTINEINSPECTION_CLEAR_WEB_FORM':
      return initialState;


    default:
      return state;
  }
};

export default routineInspectionWebFormReducer;